/**
 * Color palette for KULT MAFIA Game Master App
 * Matching mobile-app design system: Blood Red Noir
 */
export const colors = {
    // Primary colors (Blood Red)
    primary: '#DC2626',
    primaryLight: '#EF4444',
    primaryDark: '#B91C1C',
    // Secondary colors (Dark charcoal)
    secondary: '#1F1F1F',
    secondaryLight: '#2D2D2D',
    secondaryDark: '#141414',
    // Accent colors (Gold for highlights)
    accent: '#D4AF37',
    accentLight: '#E5C158',
    accentDark: '#B8960C',
    // Glow color (Red glow)
    glow: '#EF4444',
    // Background colors (Deep black)
    background: '#0A0A0A',
    surface: '#141414',
    surfaceVariant: '#1F1F1F',
    // Card colors
    cardBack: '#141414',
    cardBorder: '#2D2D2D',
    // Text colors
    textPrimary: '#F5F5F5',
    textSecondary: '#A3A3A3',
    textHint: '#737373',
    // Status colors
    success: '#22C55E',
    warning: '#F59E0B',
    error: '#EF4444',
    info: '#3B82F6',
    // Role colors (for game)
    mafia: '#DC2626',
    civilian: '#22C55E',
    detective: '#3B82F6',
    doctor: '#F5F5F5',
    don: '#7F1D1D',
    // Gradient colors for premium effects
    gradientStart: '#DC2626',
    gradientEnd: '#7F1D1D',
    // Overlay colors
    overlay: 'rgba(0, 0, 0, 0.5)',
    overlayLight: 'rgba(0, 0, 0, 0.25)',
};
